import React from 'react'

import { Typography } from 'antd'
import get from 'lodash/get'
import maxBy from 'lodash/maxBy'

import colors from '../../../../components/hocs/colors'
import { capitalize } from '../../../../utils/stringManipulation'

const { Title } = Typography

export const EmployeeBreakdownBars = ({ data = [], maxHeight = 300 }) => {
  const max = maxBy(data, 'docCount')
  const title = get(data, 'key')

  return (
    <>
      {data && !!data.length ? (
        <div>
          {title && (
            <Title level={3} style={{ textAlign: 'center' }}>
              {title}
            </Title>
          )}

          <div
            style={{
              margin: '0 auto',
              maxHeight: maxHeight,
              maxWidth: 350,
              overflow: 'auto',
              paddingBottom: 20,
            }}
            className="scrolling-container"
          >
            {data.map((child, index) => {
              const key = get(child, 'key', '')
              const docCount = get(child, 'docCount', 0)
              const maxDocCount = get(max, 'docCount', 0)
              const pct = maxDocCount ? Math.round((docCount * 100) / maxDocCount) : 0
              const barWidth = `${pct}%`

              return (
                <div key={`${child}${index}`}>
                  <div
                    style={{
                      borderRadius: 3,
                      maxWidth: '90%',
                      padding: '8px',
                      width: '90%',
                    }}
                  >
                    <div
                      aria-hidden="true"
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        textTransform: 'uppercase',
                      }}
                    >
                      {capitalize(key)}
                    </div>
                    <div
                      role="progressbar"
                      aria-label={capitalize(key)}
                      aria-valuenow={pct}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      aria-valuetext={`${pct}%`}
                      style={{
                        background: colors.blue2,
                        border: `1px solid ${colors.blue2}`,
                        width: barWidth,
                      }}
                      className="scale-bars"
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ) : null}
    </>
  )
}
